<div class="contract-data-base br-4 p-16">
    <p class="contract-options">
        <span>{{ theftProtectionString() + ',&nbsp;' }}</span>
        <span>{{ deductibleString() }}</span>
    </p>
    <dl class="grid-container">
        <div class="property g-12 sm:g-6 m-16:b">
            <dt class="label">Versicherungsnr.:</dt>
            <dd>{{ contract().insuranceNumber }}</dd>
        </div>
        <div class="property g-12 sm:g-6 m-16:b">
            <dt class="label">Zahlweise:</dt>
            <dd>{{ settlementPeriodString() }}</dd>
        </div>
        @if (contract().contractFrom) {
            <div class="property g-6 m-16:b">
                <dt class="label">Vetragsbeginn:</dt>
                <dd>{{ contract().contractFrom }}</dd>
            </div>
        }
        @if (contract().contractTo) {
            <div class="property g-6 m-16:b">
                <dt class="label">Vetragsende:</dt>
                <dd>{{ contract().contractTo }}</dd>
            </div>
        }
    </dl>
    @if (hasContractStarted()) {
        <div class="grid-container -end">
            <a
                damageReportButton
                [contract]="contract()"
                class="button -blue g-12 md:g-6"
                [routerLink]="['/', 'portal', 'meine-vertraege', this.contract().id, 'schaden-melden']"
            ></a>
        </div>
    }
</div>
